import styled from "@emotion/styled";
import Flex from "../../../../UI/Flex/Flex";
import Loading from "../../../../UI/Loading/Loading";
import ButtonGroup from "../../../../UI/ButtonGroup/ButtonGroup";
import IOButton from "../../../../UI/Form/Button/IOButton";
import Checkbox from "../../../../UI/Form/Checkbox/Checkbox";
import { scrollbarDe } from "../../../../styles/styledSnippets";
import Input from "../../../../UI/Form/Input/Input";
import useEditRememberedSettings from "./useEditRememberedSettings";

const FiltersContainer = styled.div(
  ({ theme }) => `
  height: 300px;
  overflow-y: auto;
  ${scrollbarDe(theme)};
`
);

export default function EditRememberedSettings(props) {
  const { setEditingGroup, loading, loadingOverride, Hr, ...rest } = props;

  const {
    group,
    setGroup,
    checkboxItems,
    overridenItems,
    onUpdate,
    renderItems,
  } = useEditRememberedSettings(rest);

  if (!group) {
    return <Loading />;
  }

  return (
    <div>
      <FiltersContainer>
        <Flex style={{ marginBottom: 10 }}>
          <Input
            placeholder="Name your settings"
            style={{ width: "70%" }}
            value={group.name ?? ""}
            onChange={(e) => setGroup({ ...group, name: e.target.value })}
          />
          <Checkbox
            label="Make default"
            checked={group.isDefault}
            onChange={() =>
              setGroup((group) => ({ ...group, isDefault: !group.isDefault }))
            }
          />
        </Flex>
        <div style={{ marginBottom: 10, fontWeight: 600 }}>
          Current Group Filters:
        </div>
        {renderItems(checkboxItems)}

        <Hr style={{ width: "96%", margin: "20px 0px" }} />

        <div style={{ marginBottom: 10, fontWeight: 600 }}>
          Override Group Filters:
        </div>
        {overridenItems.length ? (
          renderItems(overridenItems, true)
        ) : (
          <span style={{ fontSize: 12 }}>No Override Filters Applied</span>
        )}
      </FiltersContainer>
      <br />
      <ButtonGroup position="center" spacing={5}>
        <IOButton
          smallPadding
          cancel
          style={{ width: 100 }}
          onClick={() => setEditingGroup(null)}
        >
          Cancel
        </IOButton>

        <IOButton
          smallPadding
          add
          outline
          style={{ width: 100 }}
          onClick={() => onUpdate(true)}
          processing={loadingOverride}
          disabled={!overridenItems.length}
        >
          Override
        </IOButton>

        <IOButton
          smallPadding
          style={{ width: 100 }}
          onClick={() => onUpdate()}
          processing={loading}
        >
          Update
        </IOButton>
      </ButtonGroup>
    </div>
  );
}
